import { QueryFunctionContext, useQuery } from 'react-query';
import { useContext } from 'react';
import {
  ISMSCommunicationKeyParams,
  SMSCommunicationKeys,
  parseSMSCommunicationKey,
} from '../../cache-keys/SMSCommunicationKeys.tsx';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { sms_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function.ts';

function map({
  queryKey,
}: QueryFunctionContext<ReturnType<(typeof SMSCommunicationKeys)['filter']>>) {
  return {
    CustomerPhoneNumber: parseSMSCommunicationKey(queryKey).customerPhoneNumber,
    LoanApplicationID:
      parseSMSCommunicationKey(queryKey).filter?.applicationID ?? '',
    Limit: parseSMSCommunicationKey(queryKey).filter?.limit ?? 0,
  };
}

export function useSMSList({
  customerPhoneNumber,
  filter,
}: ISMSCommunicationKeyParams) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = SMSCommunicationKeys.filter({
    customerPhoneNumber,
    filter,
  });

  return useQuery(cacheKey, queryFunction(sms_api.findSMS(api), map), {
    enabled: state.user.token.length > 0 && !!customerPhoneNumber,
  });
}
